// extracted by mini-css-extract-plugin
module.exports = {"button":"TabButtons_button__loIUL","buttonActive":"TabButtons_buttonActive__fj70q","title":"TabButtons_title__0NdoQ"};